import Loadable from 'app/components/Loadable';
import { lazy } from 'react';
import { authRoles } from '../../auth/authRoles';

const Employee = Loadable(lazy(() => import('./Employee/Employee')));

const stockRoutes = [
    { path: '/employees',  element: <Employee />, auth: authRoles.admin },
    { path: '/employees/:id',  element: <Employee />, auth: authRoles.admin },
];

export default stockRoutes;
